import Button from '../atoms/Button';
import { FunctionComponent } from 'react';
import { useTranslation } from 'next-i18next';

export interface BottomButtonsProps {
  isPassageButtonVisible?: boolean;
  isNextButtonVisible?: boolean;
  isBackButtonVisible?: boolean;
  isPreviousButtonVisible?: boolean;
  isReviewButtonVisible?: boolean;
  isAssessTypeButtonVisible?: boolean;
  moduleName?: string;
  onClose?: () => void;
  onShowPasagge?: () => void;
  onAcademic?: () => void;
  onGeneral?: () => void;
  onNext?: () => void;
  onPrevious?: () => void;
  onReview?: () => void;
}

const BottomButtons: FunctionComponent<BottomButtonsProps> = ({
  isPassageButtonVisible = false,
  isNextButtonVisible = false,
  isBackButtonVisible = false,
  isReviewButtonVisible = false,
  isAssessTypeButtonVisible = false,
  isPreviousButtonVisible = false,
  moduleName = '',
  onClose,
  onShowPasagge,
  onAcademic,
  onGeneral,
  onNext,
  onPrevious,
  onReview,
}) => {
  const { t } = useTranslation('common');
  return (
    <>
      <div className="w-full flex justify-between mr-4 flex-row-reverse z-50 bg-white ">
        <div>
          {isPassageButtonVisible ? (
            <Button text={t('show.passage')} onClick={onShowPasagge} isSecondary={true} />
          ) : (
            ''
          )}
          {isPreviousButtonVisible ? <Button text={t('previous')} onClick={onPrevious} /> : ''}
          {isNextButtonVisible ? <Button text={t('next')} onClick={onNext} /> : ''}
          {isAssessTypeButtonVisible ? (
            <>
              <Button text={`Academic ${moduleName}`} onClick={onAcademic} />
              <Button text={t(`General ${moduleName}`)} onClick={onGeneral} />
            </>
          ) : (
            ''
          )}
          {isBackButtonVisible ? <Button text={t('close')} onClick={onClose} /> : ''}
          {isReviewButtonVisible ? <Button text={t('review')} onClick={onReview} /> : ''}
        </div>
      </div>
      {/* <div className="w-full flex justify-between mr-4"></div> */}
    </>
  );
};

export default BottomButtons;
